import logger from '3-foundation/Logging/logger';

export const mapArticleText = ({ content, settings }): Content.ContentModule => {
	try {
		return {
			documentType: content?.contentType,
			content: {
				properties: {
					content: content?.properties?.content?.markup,
				},
			},
			settings: {
				properties: settings?.properties ?? null,
			},
		};
	} catch (e) {
		logger.error(`Could not map ArticleText \nCause: ${e}`);
		throw new Error(`Could not map ArticleText \nCause: ${e}`, e);
	}
};
